import { render, staticRenderFns } from "./SelectMailSettings.vue?vue&type=template&id=2923d0df"
import script from "./SelectMailSettings.vue?vue&type=script&lang=ts"
export * from "./SelectMailSettings.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports